import AdminZoneList from '../../features/admin/AdminZoneList'

const AdminZoneListPage = () => {
  return (
  <AdminZoneList/>
  )
}

export default AdminZoneListPage